import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloormapContentComponent } from './components/floormap-content/floormap-content.component';
import { FloormapContentEditorComponent } from './components/floormap-content-editor/floormap-content-editor.component';
import { FloormapCreatorComponent } from './components/floormap-creator/floormap-creator.component';
import { FloormapItemsPaletteComponent } from './components/floormap-items-palette/floormap-items-palette.component';
import { FloormapPreviewItemComponent } from './components/floormap-preview-item/floormap-preview-item.component';
import { FloormapToolbarComponent } from './components/floormap-toolbar/floormap-toolbar.component';
import { FloormapViewerComponent } from './components/floormap-viewer/floormap-viewer.component';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, KanziPrimeUiModule,FormsModule,  TranslateModule.forChild(),],
  declarations: [
    FloormapContentComponent,
    FloormapContentEditorComponent,
    FloormapCreatorComponent,
    FloormapItemsPaletteComponent,
    FloormapPreviewItemComponent,
    FloormapToolbarComponent,
    FloormapViewerComponent
  ],
  exports: [FloormapViewerComponent, FloormapCreatorComponent,FloormapPreviewItemComponent],
})
export class KanziFloormapUiModule {}
